<script setup lang="ts">
import EditorDetailPage from '@/pages/editorDetail';
</script>

<template>
  <EditorDetailPage />
</template>
